import { z } from "zod";

export const ParticipantMilestonesSchema = z
  .object({
    learningCount: z
      .number()
      .int()
      .min(0)
      .describe("Standing things Porter learned, at every disclosure level"),
    firstRequestSentAt: z.coerce
      .date()
      .nullable()
      .describe("When the participant sent their first request"),
    firstConnectionAt: z.coerce
      .date()
      .nullable()
      .describe("When a request either way was first accepted"),
  })
  .readonly();

export type ParticipantMilestones = z.infer<typeof ParticipantMilestonesSchema>;
